import { createContext, useContext, type ReactNode } from 'react'

// Tweak T2b — read-only orchestration.
//
// EventDetail.tsx computes `archived = event.archivedAt != null` once
// and provides it via this context. Every tab component that has a
// write affordance (Add / Edit / Delete / Save button) reads it via
// useArchived() and hides those affordances when true.
//
// Important: hide WRITES, not READS. Archived events are deliberately
// still browseable — the audit value of the archive is being able to
// look back at what shipped, in situ. Only the mutation surface goes.
//
// Default false so any consumer rendered outside the provider (e.g.
// shared tab used on a non-event page in future) keeps full edit
// affordances by default.

interface ArchiveCtx {
  archived: boolean
}

const ArchiveContext = createContext<ArchiveCtx>({ archived: false })

export function ArchiveProvider({ archived, children }: { archived: boolean; children: ReactNode }) {
  return <ArchiveContext.Provider value={{ archived }}>{children}</ArchiveContext.Provider>
}

export function useArchived(): boolean {
  return useContext(ArchiveContext).archived
}
